module.exports = __webpack_public_path__ + "img/00049.26a048e5.webp";